var _defs, _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect5, _rect6, _path12, _path13, _path14, _path15, _path16, _path17, _polygon3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.89 340.04",
    "data-imageid": "personal-data",
    imageName: "CTO",
    className: "illustrations_image",
    style: {
      width: 380
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 213.73,
    y1: 242.15,
    x2: 217.65,
    y2: 343.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 117.12,
    y1: 215.85,
    x2: 104.14,
    y2: 299.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 180.38,
    y1: 213.37,
    x2: 193.96,
    y2: 183.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 218.45,
    y1: 196.11,
    x2: 200.8,
    y2: 191.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 188.9,
    y1: 154.1,
    x2: 203.41,
    y2: 206.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 200.95,
    y1: 315.77,
    x2: 199.43,
    y2: 191.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 190.95,
    y1: 231.93,
    x2: 236.52,
    y2: 228.87,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 246.96,
    y1: 275.38,
    x2: 247.42,
    y2: 254.39,
    gradientTransform: "translate(494.34 531.23) rotate(180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 271.2,
    y1: 202.34,
    x2: 294.12,
    y2: 279.48,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 279.95,
    y1: 288.34,
    x2: 283.06,
    y2: 209.45,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CTO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.16,278.59s-44.11-45.18-30.88-93,48.88-47.86,106.93-92.67S183.53,3.27,274.15,9.38,424.86,169.25,410.61,211s-26.48,73.32-26.48,73.32Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.97,
    y: 52.33,
    width: 165.23,
    height: 117.04,
    rx: 6.61,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4.97,
    y: 52.33,
    width: 165.23,
    height: 117.04,
    rx: 6.61,
    fill: "#c94ae9",
    opacity: 0.52,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.64,
    y: 261.63,
    width: 381.56,
    height: 8.15,
    fill: "#c94ae9",
    className: "target-color"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.36,
    y: 269.78,
    width: 363.54,
    height: 70.26,
    fill: "#c94ae9",
    className: "target-color"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.36,
    y: 269.78,
    width: 363.54,
    height: 16.8,
    opacity: 0.23,
    fill: "url(#linear-gradient)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "151.15 261.58 64.08 261.58 68.16 241.21 148.6 241.21 151.15 261.58",
    fill: "#c94ae9",
    className: "target-color"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.98 261.58 69 261.58 72.84 241.21 148.58 241.21 150.98 261.58",
    opacity: 0.52,
    fill: "url(#linear-gradient-2)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(90.05 255.34)",
    fontSize: 12.21,
    fontFamily: "AvenirNext-Regular, Avenir Next"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-0.01em"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.71,
    y: 0,
    letterSpacing: "-0.03em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.31,
    y: 0
  }, "O"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.68,244.86s1.79-50.91,12-56,52.19-3.06,61.35-.51,16.49,38.88,18.84,44.55c4.33,10.43,20.62,16.29,20.62,16.29l-1.53,21.38-96.73-.5S153.74,267.77,150.68,244.86Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2,186.91a4.58,4.58,0,0,0-.7,3.27,15.69,15.69,0,0,0,3.76,8.63,25.27,25.27,0,0,0,7.5,5.84c.9-2.22,1.62-6.1,3.49-6.78a59,59,0,0,1,6.07-1.06c.12-.16-5.54-1-5.73-1.08-3.54-.87-6.05-3.07-8.46-5.81a10,10,0,0,1-1.55-2.12c-.49-1-.07-2.35-1.47-2.22A4.18,4.18,0,0,0,180.2,186.91Z",
    transform: "translate(-0.81 -8.82)",
    fill: "url(#linear-gradient-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.74,200.24c.29.34.72.72,1.12.53a.93.93,0,0,0,.33-.35,7,7,0,0,0,.84-5.06,16.51,16.51,0,0,0-1.9-4.89,19.56,19.56,0,0,0-2.77-4.08c-.52-.55-1.4-1.08-2-.59a1.61,1.61,0,0,0-.44.87c-.45,1.77-4.68,8.54-3.62,10.14.41.63,4.82.23,5.56.73A14.66,14.66,0,0,1,208.74,200.24Z",
    transform: "translate(-0.81 -8.82)",
    fill: "url(#linear-gradient-4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.3,150.26c-.2-2.75-5.79-3.95-6.68-6l8.49-.34s1,11.17-3,16.63l-.87-2.12C213.29,153.23,214.75,156.66,214.3,150.26Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#984e45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.26,168.84l-3.12,19.06s7,10.26,15.86,8.73,5.6-5.86,5.6-5.86l-1.08-16.17S197.51,176.27,187.26,168.84Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#f7ad7e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.16,175.53l1.1-6.69c10.25,7.43,15.55,4.27,15.55,4.27l2.48,8.65c-1.5,1.47.33,6.78-5.61,6.18C194.78,187.46,190.15,180.8,186.16,175.53Z",
    transform: "translate(-0.81 -8.82)",
    opacity: 0.52,
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.25,155c.75,10.58,11.59,29.26,22.17,28.5s13.63-22.62,12.88-33.2S207.61,133.7,197,134.45A19.19,19.19,0,0,0,179.25,155Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#f7ad7e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188,134.72c.65-.17.85-.68,1.66-1.37,3.15-2.7,7.59-3.22,11.57-2.79,9.94,1.09,12.23,8.1,14.85,7s7.39,3.06,4.14,7.78-8.54,6-15,2.86c-4.14-2-9.87-3.59-14.47-2.43a2.63,2.63,0,0,0-1.84,1.08c-.64,1.26-.33,3.73-.29,5.11A70.78,70.78,0,0,0,189.85,162c-.53.05-.92-.47-1.16-.95-.59-1.14-1-2.37-1.54-3.52-.64-1.3-1.83-3.36-3.47-2.3a3.88,3.88,0,0,0-1.49,2.62c-.47,2.26-.11,5.51,1.77,7.1,1.51,1.27,1.95,3.68,2.31,5.51.12.58.71,2.1.49,2.63-.4.94-1.78.84-2.49.27a5.39,5.39,0,0,1-1.47-3,73.21,73.21,0,0,0-5.86-15.47,19.93,19.93,0,0,1-1.57-3.5,13.85,13.85,0,0,1,.57-8.16,14.71,14.71,0,0,1,4.33-7c2.34-1.89,4.33-1.61,7-1.48A2.36,2.36,0,0,0,188,134.72Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#984e45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.18,269.05l1.53-19.86-16.29-2.29-5.1-27.75S191.16,236.46,207,236s17.82-6.62,17.82-6.62l3,39.21Z",
    transform: "translate(-0.81 -8.82)",
    opacity: 0.23,
    fill: "url(#linear-gradient-6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.27,197.53l2.12,3.57,3.14,2.8,5.6,61.1,10.86-.34L203.5,203.22l1.61-6S198.32,196.35,195.27,197.53Z",
    transform: "translate(-0.81 -8.82)",
    fill: "url(#linear-gradient-7)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M190.31,256.49s13.58-10.86,18.33-9.51,9.85,6.45,10.19,8.15-2,4.41-4.76,4.75-5.77,2.72-7.46,2-5.77,0-7.47,2-9.51,4.75-9.51,4.75S184.54,261.58,190.31,256.49Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#f7ad7e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 192.61,
    y: 260.58,
    width: 109.12,
    height: 10.06,
    rx: 5.03,
    transform: "translate(493.54 522.41) rotate(-180)",
    fill: "#c94ae9",
    className: "target-color"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 192.61,
    y: 260.58,
    width: 109.12,
    height: 10.06,
    rx: 5.03,
    transform: "translate(493.54 522.41) rotate(-180)",
    fill: "url(#linear-gradient-8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236,261l1.65,5.34L308,270.65l20.05-50.85a4.47,4.47,0,0,0-4.15-6.11H264.25a14.4,14.4,0,0,0-13.39,9.12Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236,261l1.65,5.34L308,270.65l20.05-50.85a4.47,4.47,0,0,0-4.15-6.11H264.25a14.4,14.4,0,0,0-13.39,9.12Z",
    transform: "translate(-0.81 -8.82)",
    fill: "url(#linear-gradient-9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,270.71h72.21l19-48.3a4.24,4.24,0,0,0-3.94-5.8H266.49a13.67,13.67,0,0,0-12.72,8.66Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,270.71h72.21l19-48.3a4.24,4.24,0,0,0-3.94-5.8H266.49a13.67,13.67,0,0,0-12.72,8.66Z",
    transform: "translate(-0.81 -8.82)",
    fill: "url(#linear-gradient-10)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M378.66,176.18a29.88,29.88,0,0,0,3.3-7.76l5.83-1.12.06-6.45.06-6.45-5.81-1.22a30.1,30.1,0,0,0-3.15-7.82l3.33-4.91-4.52-4.6-4.51-4.61-5,3.24a30.13,30.13,0,0,0-7.75-3.29l-1.12-5.83-6.45-.07-6.45-.06L345.27,131a31,31,0,0,0-7.82,3.15l-4.91-3.33-4.6,4.52-4.6,4.52,3.24,5a29.88,29.88,0,0,0-3.3,7.76l-5.83,1.12-.06,6.45-.06,6.45,5.81,1.22a30.1,30.1,0,0,0,3.15,7.82L323,180.6l4.52,4.6,4.52,4.61,5-3.24a30.28,30.28,0,0,0,7.75,3.29l1.12,5.83,6.45.07,6.45.06L360,190a30.43,30.43,0,0,0,7.82-3.14l4.91,3.33,4.6-4.52,4.6-4.52Zm-37.33-4.58a15.82,15.82,0,1,1,22.37.21A15.81,15.81,0,0,1,341.33,171.6Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M320.45,141.85a20,20,0,0,0,2.19-5.17l3.88-.74,0-4.3,0-4.29-3.86-.82a20.27,20.27,0,0,0-2.1-5.2l2.22-3.27-3-3.07-3-3.06-3.31,2.15a20.13,20.13,0,0,0-5.16-2.19l-.75-3.88-4.29,0-4.3,0-.81,3.87a19.81,19.81,0,0,0-5.21,2.09l-3.27-2.21-3.06,3-3.07,3,2.16,3.31a20.43,20.43,0,0,0-2.2,5.17l-3.88.74,0,4.3,0,4.29,3.87.82a20.27,20.27,0,0,0,2.1,5.2l-2.22,3.27,3,3.07,3,3.06,3.31-2.16a19.82,19.82,0,0,0,5.16,2.2l.75,3.88,4.29,0,4.29,0,.82-3.87a20.3,20.3,0,0,0,5.21-2.09l3.26,2.21,3.07-3,3.06-3Zm-24.86-3a10.53,10.53,0,1,1,14.89.14A10.53,10.53,0,0,1,295.59,138.8Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.44 152.82 9.31 151.39 44.22 123.82 76.21 133.76 110.49 100.98 137.53 104.91 161.26 77.58 162.63 78.78 138.25 106.85 111.11 102.91 76.69 135.82 44.59 125.85 10.44 152.82",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.08,143a4.86,4.86,0,1,1-5.43-4.21A4.86,4.86,0,0,1,82.08,143Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.94,133.47a4.86,4.86,0,1,1-5.43-4.22A4.87,4.87,0,0,1,49.94,133.47Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78,149.34a5.78,5.78,0,1,1,5-6.45A5.79,5.79,0,0,1,78,149.34Zm-1.22-9.65a4,4,0,1,0,4.41,3.43A4,4,0,0,0,76.76,139.69Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.39,110.46a4.86,4.86,0,1,1-5.43-4.21A4.85,4.85,0,0,1,116.39,110.46Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.29,116.8a5.78,5.78,0,1,1,5-6.45A5.79,5.79,0,0,1,112.29,116.8Zm-1.21-9.65a4,4,0,1,0,4.41,3.43A3.95,3.95,0,0,0,111.08,107.15Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.27,113.92a4.86,4.86,0,1,1-5.43-4.22A4.88,4.88,0,0,1,143.27,113.92Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#c94ae9",
    className: "target-color"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.17,120.25a5.77,5.77,0,1,1,5-6.45A5.78,5.78,0,0,1,139.17,120.25ZM138,110.61a3.95,3.95,0,1,0,4.41,3.42A3.94,3.94,0,0,0,138,110.61Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.87,139.83a5.78,5.78,0,1,1,5-6.45A5.79,5.79,0,0,1,45.87,139.83Zm-1.22-9.65a4,4,0,1,0,4.41,3.43A3.95,3.95,0,0,0,44.65,130.18Z",
    transform: "translate(-0.81 -8.82)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg);
export default __webpack_public_path__ + "static/media/bannerImg.d142eb57bd09dc0b9fe0b2a419a29f8d.svg";
export { ForwardRef as ReactComponent };